import { fetch } from '@atlassian/eoc-fetch';
import { urls } from '../../../common/constants/urls';
const orderRotation = ({
  scheduleId,
  after,
  rotationId
}) => {
  return fetch(urls.schedules.scheduleId.rotations.rotationId.order.url({
    rotationId,
    scheduleId
  }), {
    method: 'PATCH',
    body: {
      after
    }
  });
};
const getRotation = ({
  scheduleId,
  rotationId
}) => {
  return fetch(urls.schedules.scheduleId.rotations.rotationId.url({
    scheduleId,
    rotationId
  }), {
    method: 'GET'
  });
};
const deleteRotation = ({
  scheduleId,
  rotationId
}) => {
  return fetch(urls.schedules.scheduleId.rotations.rotationId.url({
    scheduleId,
    rotationId
  }), {
    method: 'DELETE'
  });
};
const addRotation = ({
  name,
  startTime,
  responders,
  restrictions,
  rotationType,
  hasEndTime,
  rotationPeriod,
  endTime,
  scheduleId,
  timeTemplateId,
  timingType
}) => {
  return fetch(urls.schedules.scheduleId.rotations.url({
    scheduleId
  }), {
    method: 'POST',
    body: {
      name,
      responders,
      restrictions,
      rotationType,
      timeTemplateId,
      timingType,
      rotationPeriod,
      startTime,
      endTime,
      hasEndTime
    }
  });
};
const editRotation = ({
  id,
  name,
  startTime,
  responders,
  restrictions,
  rotationType,
  rotationPeriod,
  hasEndTime,
  timingType,
  endTime,
  scheduleId,
  timeTemplateId
}) => {
  return fetch(urls.schedules.scheduleId.rotations.rotationId.url({
    scheduleId,
    rotationId: id
  }), {
    method: 'PUT',
    body: {
      id,
      name,
      responders,
      restrictions,
      rotationType,
      rotationPeriod,
      timeTemplateId,
      timingType,
      startTime,
      endTime,
      hasEndTime
    }
  });
};
const getScheduleTimeTemplates = () => {
  return fetch(urls.schedules.timeTemplates.rotation.url(), {
    method: 'GET'
  });
};
export const endpoints = {
  deleteRotation,
  getRotation,
  orderRotation,
  addRotation,
  editRotation,
  getScheduleTimeTemplates
};